import { Navigate } from 'react-router-dom';

const ValidationRoute = ({ element }) => {
    const token = sessionStorage.getItem("token");
    return token ? element : <Navigate to="/Login" />;
};

export default ValidationRoute;